import { ConfirmDeletionDialog } from "../confirm-deletion";
import { deleteTeam } from "@/lib/supabase";
import { useLocation } from "wouter";
import { useState } from "react";
import { Separator } from "@/components/ui/separator";
import { BasicsForm } from "./settings-form";
import { NestedTeam } from "@revelate/types";
import type { KeyedMutator } from "swr";

export const SettingsPage = ({
  team,
  mutate,
}: {
  team?: NestedTeam;
  mutate: KeyedMutator<NestedTeam | null>;
}) => {
  const [, navigate] = useLocation();
  const [error, setError] = useState("");
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium">General</h3>
        <p className="text-sm text-muted-foreground">
          Configure the basics of your team
        </p>
      </div>
      <Separator />
      <BasicsForm team={team} mutate={mutate} />
      {team && <div className="flex items-center gap-3 text-sm">
        <span>Delete team</span>
        <ConfirmDeletionDialog deleteId={String(team.id)} deleteOperation={async () => {
          try { await deleteTeam(team.id); navigate("/teams"); }
          catch { setError("Could not delete this team. Move its subteams first and try again."); }
        }} />
      </div>}
      {error && <p role="alert" className="text-sm text-destructive">{error}</p>}
    </div>
  );
};
